import React from 'react'
import { useTranslation } from 'react-i18next'
import { pathOr } from 'ramda'
import { Form } from 'antd'
import { Input } from '@shared/Form'

import { Field, TableColumn as Column } from 'src/components/Form'
import OptionsSelect from 'src/components/OptionsSelect'
import { FormInstance } from 'antd/es/form/Form'
import UploadButton from 'src/components/UploadButton'
import { rules } from '@shared/innmaxLib/utils/form'

type Props = {
  item?: any
  isEdit: boolean
  isCreate?: boolean
  form?: FormInstance
}

function RepairFields(props: Props) {
  const { t } = useTranslation()

  const { item, form, isCreate, isEdit } = props
  const [deviceType, setDeviceType] = React.useState()
  const [editable, setEditable] = React.useState<boolean>(false)

  const sessionId = Form.useWatch('sessionId', form)

  const handleChangeDeviceType = (val: any) => {
    setDeviceType(val)
    form?.setFieldValue('deviceSeq', undefined)
    form?.setFieldValue(['reportData', 'reason'], undefined)

    return val
  }

  const handleChangeDisplayName = (val: any) => {
    const edit = val ? false : true
    setEditable(edit)
    return val
  }

  React.useEffect(() => {
    if (isEdit) {
      const deviceSeq = item?.deviceSeq
      const edit = deviceSeq ? false : true
      setDeviceType(item?.deviceType)
      setEditable(edit)
    } else {
      setEditable(false)
    }
  }, [isEdit])

  return (
    <>
      <Column
        {...props}
        title={['案件編號', '報修來源']}
        renderLeft={(props: any) =>
          isCreate ? '自動產生' : pathOr('', ['ticketNo'], item)
        }
        renderRight={props =>
          isCreate ? '' : pathOr('', ['ticketSourceStr'], item)
        }
      />
      <Column
        {...props}
        title={['設備種類', '案件進度']}
        renderLeft={props => (
          <Field
            {...props}
            name={['deviceType']}
            value={pathOr('', ['deviceTypeStr'], item)}
            initialValue={pathOr('', ['deviceType'], item)}
            getValueFromEvent={handleChangeDeviceType}>
            <OptionsSelect.DeviceSelect
              className="w-full"
              others={[
                {
                  value: 'other',
                  name: '其他',
                },
              ]}
            />
          </Field>
        )}
        renderRight={() =>
          isCreate ? '待派工' : pathOr('', ['stateStr'], item)
        }
      />
      <Column
        {...props}
        title={[t('option:report reason')]}
        renderLeft={props => (
          <Field
            {...props}
            name={['reportData', 'reason']}
            value={pathOr('', ['reportData', 'reason'], item)}
            initialValue={pathOr('', ['reportData', 'reason'], item)}>
            <OptionsSelect.ReportReasonSelect
              deviceType={deviceType}
              className="w-full"
            />
          </Field>
        )}
        renderRight={() => ''}
      />
      <Column
        {...props}
        title={['區域', '報修時間']}
        renderLeft={props => (
          <Field
            {...props}
            name="sessionId"
            value={pathOr('', ['sessionName'], item)}
            initialValue={pathOr('', ['sessionId'], item)}>
            <OptionsSelect.SessionSelect
              className="w-full"
              onChange={() => form?.setFieldValue('deviceSeq', undefined)}
            />
          </Field>
        )}
        renderRight={() => pathOr('', ['createAtStr'], item)}
      />
      <Column
        {...props}
        title={[t('repair:display name'), '是否駁回']}
        renderLeft={props => (
          <Field
            {...props}
            name={['deviceSeq']}
            value={pathOr('', ['deviceDisplayName'], item)}
            initialValue={pathOr('', ['deviceSeq'], item)}
            getValueFromEvent={handleChangeDisplayName}>
            <OptionsSelect.DeviceDisplayNemeSelect
              deviceType={deviceType}
              sessionId={sessionId}
              className="w-full"
            />
          </Field>
        )}
        renderRight={() => ''}
      />

      <Column
        {...props}
        title={['經度', '緯度']}
        field={['lon', 'lat']}
        editable={editable}
        renderLeft={() =>
          editable ? (
            <Field
              {...props}
              name="lon"
              initialValue={pathOr('', ['lon'], item)}>
              <Input className="w-full" />
            </Field>
          ) : (
            pathOr('', ['lon'], item)
          )
        }
        renderRight={() =>
          editable ? (
            <Field
              {...props}
              name="lat"
              initialValue={pathOr('', ['lat'], item)}>
              <Input className="w-full" />
            </Field>
          ) : (
            pathOr('', ['lat'], item)
          )
        }
      />
      <Column
        {...props}
        title={['地址']}
        editable={editable}
        renderLeft={props =>
          editable ? (
            <Field
              {...props}
              name="address"
              initialValue={pathOr('', ['address'], item)}>
              <Input className="w-full" />
            </Field>
          ) : (
            pathOr('', ['address'], item)
          )
        }
      />
      <Column
        {...props}
        title={['報修照片']}
        renderLeft={(props: any) => {
          return (
            <div>
              <Form.Item noStyle className="w-full" name={['reportPhotos']}>
                <UploadButton.PhotosUpload
                  uploadOwner="repairTicket"
                  defaultFiles={pathOr([], ['reportData', 'imgs'], item)}
                  isEdit={props.isEdit}
                />
              </Form.Item>
            </div>
          )
        }}
      />
      <Column
        {...props}
        title={['報修備註']}
        renderLeft={props => (
          <Field
            {...props}
            name={['reportData', 'note']}
            value={pathOr('', ['reportData', 'note'], item)}
            initialValue={pathOr('', ['reportData', 'note'], item)}>
            <Input className="w-full" />
          </Field>
        )}
      />
    </>
  )
}
export default React.memo(RepairFields)
